import { BugReportEndpoint } from '@/core/network/api/constants/api.url.constant';
import type { HttpClient } from '@/core/network/http/httpClient';
import type { GamResponse } from '@/core/network/http/httpClient.interface';
import type { AxiosResponse } from 'axios';

export interface CreateBugReportPayload {
  message: string;
  metadata: Record<string, unknown>;
}

export class BugReportApi {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  async create(payload: CreateBugReportPayload): Promise<AxiosResponse<GamResponse<unknown>>> {
    return await this.httpClient.post(BugReportEndpoint.CREATE, {
      data: payload,
    });
  }
}
